import styled from 'styled-components';
import SubTitle from 'js/components/core/SteppedPage/SubTitle';

export default styled(SubTitle)`
  font-weight: bold;
  font-size: 1.2rem;
`;
